import noop from '@atlaskit/ds-lib/noop';

import { type Context, createContext, useContext } from 'react';

/**
 * __Is open context__
 *
 * A context for storing the isOpen value of the FlyoutMenuItem.
 */
export const IsOpenContext: Context<boolean> = createContext(false);

/**
 * __Set is open context__
 *
 * A context for storing a function that sets isOpen value of the FlyoutMenuItem.
 */
export const SetIsOpenContext: Context<(value: boolean) => void> =
	createContext<(value: boolean) => void>(noop);

export const useFlyoutMenuOpen = (): boolean => useContext(IsOpenContext);

export const useSetFlyoutMenuOpen = (): ((value: boolean) => void) => useContext(SetIsOpenContext);
